/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
// Box migrated to UDS
import { Checkbox, Box, StackView, Spacer, ExpandCollapse, Typography } from '@telus-uds/components-web';
import {
  subscriberDetailsContractTerm,
  contractTerm3Year
} from '../../../utils/constant';
import { getFieldValue } from '../../utils';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../../contentful';
import { getPathVariables } from '../../../misc';

const RegularFeatures = ({
  formFields,
  selectedFeatures,
  setSelectedFeatures,
  showOnlyCategories
}) => {
  const [regularFeatures, setRegularFeatures] = useState();
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'wirelessSubscribersFeatures',
    locale
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      setRegularFeatures(getData(res));
    });
  }, []);

  const valueContractTerm = getFieldValue(
    subscriberDetailsContractTerm,
    formFields
  );
  const onFeatureSelect = (featureValue) => (checked) => {
    if (checked) {
      // Add feature if not already selected
      if (_.find(selectedFeatures, featureValue) === undefined) {
        setSelectedFeatures([...selectedFeatures, featureValue]);
      }
    } else {
      // Remove feature
      const newFeatureList = selectedFeatures.filter(
        feature => feature.id !== featureValue.id
      );
      setSelectedFeatures([...newFeatureList]);
    }
  };
  const getFeatureValue = feature => {
    const featureValue = {
      id: _.get(feature, 'sys.id', uuidv4()),
      name: _.get(feature, 'fields.name', ''),
      price: _.get(feature, 'fields.price', '')
    };
    return JSON.stringify(featureValue);
  };

  return (
    <>
      {selectedFeatures && regularFeatures && (
        <ExpandCollapse maxOpen={1}>
          {(expandProps) => (
            <>
              {regularFeatures.categories.map(category => {
                if (
                  !showOnlyCategories.length &&
                  valueContractTerm !== contractTerm3Year[0] &&
                  valueContractTerm !== contractTerm3Year[1]
                ) {
                  return (
                    <ExpandCollapse.Panel
                      key={`features-${category.sys.id}`}
                      {...expandProps}
                      panelId={`features-${category.sys.id}`}
                      control={<Typography variant={{ size: 'h4' }}>{_.get(category, 'fields.categoryName', '')}</Typography>}
                    >
                      <StackView space={2}>
                        {_.get(category, 'fields.features', []).map(feature => {
                            if(feature.fields.name === 'Stream+ ($25.00)'){
                              return null;
                            }
                          const featureValue = {
                            id: _.get(feature, 'sys.id', uuidv4()),
                            name: _.get(feature, 'fields.name', ''),
                            price: _.get(feature, 'fields.price', '')
                          };
                          return (
                            <Checkbox
                              key={_.get(feature, 'sys.id', uuidv4())}
                              checked={
                                selectedFeatures.length > 0 &&
                                !!_.find(selectedFeatures, featureValue)
                              }
                              onChange={onFeatureSelect(featureValue)}
                              name="feature"
                              value={getFeatureValue(feature)}
                              label={_.get(feature, 'fields.name', '')}
                            />
                          );
                        })}
                      </StackView>
                    </ExpandCollapse.Panel>
                  );
                } else {
                  if (showOnlyCategories.includes(category.fields.categoryName)) {
                    return (
                      <ExpandCollapse.Panel
                        key={`features-${category.sys.id}`}
                        {...expandProps}
                        panelId={`features-${category.sys.id}`}
                        control={<Typography variant={{ size: 'h4' }}>{_.get(category, 'fields.categoryName', '')}</Typography>}
                      >
                        <StackView space={2}>
                          {_.get(category, 'fields.features', []).map(feature => {
                            const featureValue = {
                              id: _.get(feature, 'sys.id', uuidv4()),
                              name: _.get(feature, 'fields.name', ''),
                              price: _.get(feature, 'fields.price', '')
                            };
                            return (
                              <Checkbox
                                key={_.get(feature, 'sys.id', uuidv4())}
                                checked={
                                  selectedFeatures.length > 0 &&
                                  !!_.find(selectedFeatures, featureValue)
                                }
                                onChange={onFeatureSelect(featureValue)}
                                name="feature"
                                value={getFeatureValue(feature)}
                                label={_.get(feature, 'fields.name', '')}
                              />
                            );
                          })}
                        </StackView>
                      </ExpandCollapse.Panel>
                    );
                  }
                }
                return null;
              })}
            </>
          )}
        </ExpandCollapse>
      )}
    </>
  );
};

RegularFeatures.propTypes = {
  formFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired,
  showOnlyCategories: PropTypes.array
};

export default RegularFeatures;
